import * as dispatchers from './dispatchers';
import * as selectors from './selectors';
import {reducer} from './reducers';

export const responses = {
    dispatchers,
    selectors,
    reducer,
};
